module.exports = __webpack_public_path__ + "static/media/9DESA34.4f1cb84e.jpg";